import React from "react";
import { Link } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
export default function Claims() {
    useScrollAnimation();
    return (
        <>
            <section className="landingpages">
                <div className="container h-[75%] flex flex-col gap-[5px] items-center justify-center">
                    <div className="text-white font-bold capitalize text-[40px] btmAni2000">Claims</div>
                    <div className="flex items-center text-[20px] gap-[4px] text-white btmAni25002">
                        <Link className="text-white" to={"/"}>Home</Link>
                        -
                        <span className="text-white">Claims</span>
                    </div>
                </div>
            </section>
            <section className="pb-[40px]">
                <div className="container flex flex-col gap-[40px]">
                    <div className="flex flex-col gap-[5px] items-center justify-center">
                        <div className="t-center flex items-center justify-center text-[35px] font-bold text-[#294a6a] capitalize btmAni20002">For Claims</div>
                        <p className="w-100 w-[75%] text-[#294a6a] text-[20px] capitalize m-auto text-center btmAni3000">
                            contact us please
                        </p>
                    </div>
                    <form action="https://mpowermoving-services.com/claim.php" method="POST">
                        <div class="flex flex-col gap-[15px]">
                            <div class="flex flex-col gap-[8px]">
                                <div class="f-col flex items-center gap-[10px] justify-between">
                                    <div class="w-100 w-[48%] flex flex-col gap-[5px] btmAni2500">
                                        <label class="font-bold text-[20px] text-[#294a6a]">First Name</label>
                                        <input type="text" name="first_name" placeholder="First Name" class="outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]" required />
                                    </div>
                                    <div class="w-100 w-[48%] flex flex-col gap-[5px] btmAni2500">
                                        <label class="font-bold text-[20px] text-[#294a6a]">Last Name</label>
                                        <input type="text" name="last_name" placeholder="Last Name" class="outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]" required />
                                    </div>
                                </div>
                                <div class="f-col flex items-center gap-[10px] justify-between">
                                    <div class="w-100 w-[48%] flex flex-col gap-[5px] btmAni2500">
                                        <label class="font-bold text-[20px] text-[#294a6a]">Email</label>
                                        <input type="email" name="email" placeholder="Your Email" class="outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]" required />
                                    </div>
                                    <div class="w-100 w-[48%] flex flex-col gap-[5px] btmAni2500">
                                        <label class="font-bold text-[20px] text-[#294a6a]">Phone Number</label>
                                        <input type="text" name="phone" placeholder="Your Phone Number" class="outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]" required />
                                    </div>
                                </div>
                                <div class="w-[100%] flex flex-col gap-[5px] btmAni2500">
                                    <label class="font-bold text-[20px] text-[#294a6a]">Message</label>
                                    <textarea name="message" placeholder="Your Message" class="h-[250px] max-h-[350px] outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]"></textarea>
                                </div>
                            </div>
                            <button class="btmAni30002 w-fit bg-[#294a6a] py-[6px] px-[20px] font-bold rounded-[4px] text-white" type="submit">Submit Form</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
}